// Labels for the CHAMP family page (guardians, players, active/past
// enrollments) and the family sections that replace Atomic's company ones.
export const champFamilyMessages = {
  resources: {
    companies: {
      field_categories: {
        contact: "Contact",
        address: "Address",
        additional_info: "Notes",
      },
      fields: {
        description: "Notes",
      },
      champ: {
        guardians: "Guardian |||| Guardians",
        players: "Player |||| Players",
        no_guardians: "No guardian yet.",
        no_players: "No player yet.",
        relationship_unknown: "Relationship not set",
        age: "%{smart_count} year old |||| %{smart_count} years old",
        age_unknown: "Age unknown",
        no_current_classes: "Not in a class right now",
        enrollments_active: "Active (%{smart_count})",
        enrollments_in_progress: "In progress (%{smart_count})",
        enrollments_past: "Past (%{smart_count})",
        no_enrollments: "None.",
        no_class: "No class linked",
        archived: "Archived",
        people_tab: "People (%{smart_count})",
      },
    },
  },
};
